"use client";

import { useEffect } from "react";
import { afterInitialPaint } from "@/lib/after-initial-paint";

// Existing public Web Analytics token, shared with automatic injection.
const BEACON_CONFIG = {"version": "2024.11.0", "token": "7f7df938f62d4ce7bd59bb3c7cb5e80d", "r": 1, "spa": 2};

export function CloudflareAnalytics() {
  useEffect(() => {
    if (!["www.finda.show", "finda.show"].includes(location.hostname)) return;
    afterInitialPaint(() => {
      // Routes and signed-in requests may still receive automatic injection.
      if (document.querySelector("script[data-cf-beacon]")) return;
      const script = document.createElement("script");
      script.src = "https://static.cloudflareinsights.com/beacon.min.js";
      script.async = true;
      script.dataset.cfBeacon = JSON.stringify(BEACON_CONFIG);
      document.head.appendChild(script);
    });
  }, []);
  return null;
}
